import { ComponentRef, Directive, ElementRef, Input, OnChanges, Renderer2, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[blocked]',
  standalone: true,
})
export class BlockUiDirective implements OnChanges {
  @Input() blocked!: boolean;
  @Input() autoZIndex = true;
  @Input() baseZIndex = 0;
  @Input() styleClass = 'block-ui';
  @Input() text = '';

  blockUiComponentInstance: ComponentRef<any>;
  originalPosition: string;
  blockedElement: HTMLElement
  constructor(
    private el: ElementRef,
    protected vcr: ViewContainerRef,
    protected renderer: Renderer2
  ) {
  }

  applyPosition() {
    if (!['relative', 'absolute', 'fixed'].includes(this.originalPosition)) {
      this.el.nativeElement.style.position = 'relative'
    }
  }

  ngOnChanges(): void {
    if (this.blocked) {
      this.originalPosition = this.el.nativeElement.style.position
      this.blockedElement = this.renderer.createElement('div');
      this.renderer.addClass(this.blockedElement, this.styleClass)
      this.renderer.setProperty(this.blockedElement, 'innerHTML', this.styleClass)
      this.blockUiComponentInstance = this.el.nativeElement.append(this.blockedElement);
      this.applyPosition();
    } else {
      if (this.blockedElement) {
        this.blockedElement.remove();
      }
      this.el.nativeElement.style.position = this.originalPosition;
    }
  }
}
